var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticStyle:{"stroke-width":"0px"},attrs:{"d":"M12,3c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7,4.7-2.1,4.7-4.7-2.1-4.7-4.7-4.7Z"}}),_c('path',{staticStyle:{"stroke-width":"0px"},attrs:{"d":"M17.9,15.6c-1.3-1.3-3-2-4.9-2h-2.1c-1.8,0-3.6.7-4.9,2-1.3,1.3-2,3-2,4.9s.2.5.5.5h14.8c.3,0,.5-.2.5-.5,0-1.8-.7-3.6-2-4.9Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }